<template>
  <div class="vx-row">
    <div class="vx-col mb-base w-full">
      <div class="vx-card">
        <vx-card title="Telas Capturadas" v-viewer>
          <div class="vx-row pt-2">
            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
                </div>
              </vs-col>
            </div>

            <div class="vx-col w-1/2 sm:w-4/12 text-center mt-2 mb-4" v-for="(img, index) in data" :key="index">
              <img :src="img.url" :alt="img.date | formatDateTimeNoLocal" class="rounded mb-4 user-latest-image responsive" />
              <div>{{ img.datetime | formatDateTimeNoLocal }}</div>
            </div>

            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page"></vs-pagination>
                </div>
              </vs-col>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      meta: {
        pagination: {
          total_pages: 0
        }
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: "Todos os Registros"
    };
  },

  watch: {
    page: function() {
      this.load();
    }
  },

  mounted() {
    this.load();
  },

  methods: {
    handleChangePage: function(page) {
      this.page = page;
      this.load();
    },
    load: function() {
      this.$api
        .get(
          "/api/v1/desktop/screenshot/" +
            this.$localStorage.get("licencekey") +
            "?page=" +
            this.page +
            "&dateFilterId=" +
            this.dateFilterId
        )
        .then(response => {
          this.data = response.data.data;
          this.meta = response.data.meta || { pagination: { total_pages: 0 } };
        });
    },
    setDateFilter: function(filterId) {
      this.dateFilterId = filterId;
      this.load();

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = "Hoje";
          break;
        case 1:
          this.dateFilterText = "Ontem";
          break;
        case 2:
          this.dateFilterText = "Últimos 7 dias";
          break;
        case 3:
          this.dateFilterText = "Últimos 30 dias";
          break;
        case 4:
          this.dateFilterText = "Últimos 90 dias";
          break;
        case 5:
          this.dateFilterText = "Todos os Registros";
          break;
      }
    }
  }
};
</script>

<style>
.viewer-button {
  top: 20px;
  z-index: 10000000;
}
</style>
